import isNil from 'lodash/isNil'
import moment from 'moment-timezone'

import { hasText, isValidDate } from './helpers'

function getSignedOnDateMessage(answer) {
  const ip_address = answer?.ip_address ?? null
  const updated_at =
    answer && (answer.updated_at || answer.created_at)
      ? answer.updated_at || answer.created_at
      : null

  const localDate = moment.utc(updated_at).tz(moment.tz.guess())
  const zoneAbbreviation = localDate.format('z')

  return `Signed${
    !isNil(updated_at) && isValidDate(new Date(updated_at))
      ? ` on ${localDate.format(`L [at] LTS [${zoneAbbreviation}]`)}`
      : ''
  }${hasText(ip_address) ? ` from ${ip_address}` : ''}`
}

export default getSignedOnDateMessage
